import React from "react";

// Estas constantes definen el estilo del nodo
// TODO: Unificar estas constantes con el typeNodeData para que sea un solo origen de datos
export const ROOM_NODE = "room";
export const STAIRS_ELEVATOR_NODE = "elev_stairs";
export const SERVICE_NODE = "service";
export const BAR_REST_NODE = "bar_rest";
export const GYM_SPA_NODE = "gym_spa";
export const LOBBY_NODE = "lobby";
export const ACCESS_NODE = "access";

export const typeNodeData = [
     { id: 'room'           , code : 'Cuarto'}
    , { id: 'lobby'         , code : 'Lobby'}
    , { id: 'access'         , code : 'Acceso'}
    , { id: 'service'       , code : 'Servicio'}
    , { id: 'elev_stairs'   , code : 'Elevador / Escaleras'}
    , { id: 'bar_rest'      , code : 'Bar / Restaurante'}
    , { id: 'gym_spa'       , code : 'Spa / Gimnasio'}
];

export const nodeTypes = [
    ROOM_NODE,
    STAIRS_ELEVATOR_NODE,
    SERVICE_NODE,
    BAR_REST_NODE,
    GYM_SPA_NODE,
    LOBBY_NODE,
    ACCESS_NODE
];

const RoomShape = (
    <symbol
        viewBox="0 0 65 65"
        width="65"
        height="65"
        id="room"
        onClick={() => console.log("tim")}
    >
        <rect x="0" y="0" rx="2" ry="2"
              width="65"
              height="65"
              stroke={"#76affa"}
              strokeWidth="3"
        />
    </symbol>
);

const ElevShape = (
    <symbol
        viewBox="0 0 60 60"
        width="60"
        height="60"
        id="elev_stairs"
        onClick={() => console.log("tim")}
    >
        <rect
            x="0" y="0" rx="2" ry="2"
            width="60"
            height="60"
            stroke={"#76fad2"}
            strokeWidth="3"
        />
    </symbol>
);

const BarRestShape = (
    <symbol viewBox="0 0 100 80"
            id="bar_rest"
            width="100"
            height="80"
    >
        <rect
            transform="translate(0) rotate(0)"
            width="100"
            height="80"
            stroke={"#ba76fa"}
            strokeWidth="3"
        />
    </symbol>
);

const ServiceShape = (
    <symbol
        viewBox="0 0 60 60"
        width="60"
        height="60"
        id="service"
        onClick={() => console.log("tim")}
    >
        <rect
            x="0" y="0" rx="2" ry="2"
            width="60"
            height="60"
            stroke={"#fab176"}
            strokeWidth="3"
        />
    </symbol>
);

const AccessShape = (
    <symbol
        viewBox="0 0 40 40"
        width="40"
        height="40"
        id="access"
        onClick={() => console.log("tim")}
    >
        <rect
            x="0" y="0" rx="2" ry="2"
            width="40"
            height="40"
            stroke={"#8f6b53"}
            strokeWidth="3"
        />
    </symbol>
);

const LobbyShape = (
    <symbol
        viewBox="0 0 120 120"
        width="120"
        height="120"
        id="lobby"
        onClick={() => console.log("tim")}
    >
        <rect
            x="0" y="0" rx="2" ry="2"
            width="120"
            height="120"
            stroke={"#fa9544"}
            strokeWidth="5"
        />
    </symbol>
);

export default {
    NodeTypes: {
        lobby: {
            shape: LobbyShape,
            shapeId: "#lobby",
            typeText: "Lobby"
        },
        room: {
            shape: RoomShape,
            shapeId: "#room",
            typeText: "Room"
        },
        service: {
            shape: ServiceShape,
            shapeId: "#service",
            typeText: ""
        },
        access: {
            shape: AccessShape,
            shapeId: "#access",
            typeText: ""
        },
        elev_stairs: {
            shape: ElevShape,
            shapeId: "#elev_stairs",
            typeText: "Elev"
        },
        bar_rest: {
            shape: BarRestShape,
            shapeId: "#bar_rest",
            typeText: "Bar/Rest"
        },
        gym_spa: {
            shape: RoomShape,
            shapeId: "#room",
            typeText: "Elev"
        }
    }
};